module.exports = __webpack_public_path__ + "static/media/avatar.4e2f72e7.gif";